import API from '../api';
import { GLOBAL_SESSION_KEYS } from '../page-component';
import { Session, platformDetector } from './index';
export default class Wechat {
  WECHAT_JSSDK_DEBUG = process.env.REACT_APP_WECHAT_DEBUG === "true";
  // 微信权限列表，需要在.config的时候提供
  WECHAT_JSSDK_JSAPI_LIST = [
    'chooseImage',
    'previewImage',
    'uploadImage',
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'onMenuShareQQ',
    'onMenuShareWeibo',
    'onMenuShareQZone',
    'getLocation',
    'chooseWXPay'
  ];

  constructor(callback) {
    this.wx = window.wx;

    //为了解决初始化微信config与API包加载先后问题
    setTimeout(async () => {
      // 获取wx config 参数
      function fetchWxConfig({ WECHAT_JSSDK_DEBUG, WECHAT_JSSDK_JSAPI_LIST }) {
        return new Promise(async resolve => {
          try {
            let url = window.location.href.split('#')[0]
            console.log('wechat jssdk send url : ', url)
            const { data } = await API.getJSSDKConfig(url);
            resolve({
              debug: WECHAT_JSSDK_DEBUG,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: WECHAT_JSSDK_JSAPI_LIST
            })
          } catch (error) {
            console.error("获取wx config参数接口错误", JSON.stringify(error))
            callback();
          }
        })
      }

      try {
        const platform = platformDetector()

        // debug 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        // appId 必填，企业号的唯一标识，此处填写企业号corpid
        // timestamp 必填，生成签名的时间戳
        // nonceStr 必填，生成签名的随机串
        // signature 必填，签名，见附录1
        // jsApiList 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        let wxConfig = null
        // !important
        // iOS需要使用第一次进入页面的URL获取签名，安卓每次路由切换都重新配置签名
        // ref: https://segmentfault.com/a/1190000012339148
        switch (platform) {
          case 'android':
            wxConfig = await fetchWxConfig(this);
            console.info('android wx config', JSON.stringify(wxConfig));
            this.wx.config(wxConfig);
            break

          case 'ios':
            wxConfig = Session.get(GLOBAL_SESSION_KEYS.WECHAT_CONFIG)
            if (!wxConfig) {
              wxConfig = await fetchWxConfig(this);
              console.info('ios wx config', JSON.stringify(wxConfig));
              this.wx.config(wxConfig);

              Session.set(GLOBAL_SESSION_KEYS.WECHAT_CONFIG, wxConfig);
            }
            break
          default:
            console.error('不是android或ios，设备无法识别')
            break
        }

        // 微信config 失败或者成功 都会调用 ready
        this.wx.ready(() => {
          console.info('wx ready')
          // 在jssdk ready后，再去配置一次微信、小程序的环境变量
          // https://developers.weixin.qq.com/blogdetail?action=get_post_info&lang=zh_CN&token=&docid=42b6819eaa4c61a048cf99ed373798f9
          //微信环境变量
          window.isWx = !!window.navigator.userAgent.match(/MicroMessenger/i)
          //微信小程序环境变量
          window.isMiniprogram = window.__wxjs_environment === 'miniprogram'
          window.browserEnv = window.__wxjs_environment === 'miniprogram' ? 'miniprogram' : 'default'
          callback();
        });

        // 微信config 失败 会调用 error
        this.wx.error(error => {
          console.log('wx error', JSON.stringify(error));
        })

      } catch (error) {
        console.error('微信config异常', error)
      }
    }, 0);
  }


  /**
   * 调用微信jssdk功能
   * 
   * 关于回调问题，根据jssdk源码，回调分为四种
   * 
   * success 调用成功后回调
   * fail 调用失败后回调
   * cancel 调用取消（如取消微信支付）
   * complete 调用完成，无论调用成功或失败
   * 
   * 所以在invoke后，返回的promise里面，resolve对应success，reject对应fail和cancel
   * 
   * @param {*} methodName 
   * @param {*} params 
   * @param {*} sync 如果是同步操作，会直接在执行完wx的方法后调用resolve，默认是false，通过wx需要的params里面设置success、fail等回调
   */
  invoke(methodName = '', params, sync = false) {
    return new Promise((resolve, reject) => {
      if (methodName) {
          this.wx.ready(() => {
            if (sync) {
              this.wx[methodName](params);
              resolve()
            } else {
              params.success = resolve
              params.fail = reject
              params.cancel = reject
              this.wx[methodName](params);
            }
          })
      } else {
        console.error('methodName must require');
        reject('methodName must require')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/wechat.js